<template>
  <div>
    <input
      v-show="false"
      type="file"
      ref="file"
      @change="uploadImage($event)"
      accept="image/*"
    />

    <StandardCard subheader="INFO">
      <template v-slot:top>
        <v-list color="cardSurface" class="py-0">
          <v-list-item>
            <v-list-item-content>
              <v-btn class="editProfile" @click.stop="edit" fab small>
                <v-icon>mdi-account-edit</v-icon>
              </v-btn>

              <v-avatar class="mt-4" size="96">
                <img
                  :lazy-src="
                    contactpersonApi.getProfilePhoto(
                      value.person.email,
                      profileImageUpdate,
                      '96x96'
                    )
                  "
                  :src="
                    contactpersonApi.getProfilePhoto(
                      value.person.email,
                      profileImageUpdate,
                      '96x96'
                    )
                  "
                />

                <v-avatar
                  class="overlayAvatar"
                  size="96"
                  @mouseenter="hover = true"
                  @mouseleave="hover = false"
                  @click="$refs.file.click()"
                >
                  <v-overlay :absolute="true" :value="hover">
                    <span class="white--text">Endre</span>
                  </v-overlay>
                </v-avatar>
              </v-avatar>

              <div class="text-center">
                <v-list-item-title class="mt-3">
                  <h3 class="primary--text headline font-weight-bold">
                    {{ value.person.fullName }}
                  </h3>
                </v-list-item-title>
                <v-list-item-subtitle class="mt-1 mb-1">
                  <h3>
                    {{ value.contact.name }}
                  </h3>
                </v-list-item-subtitle>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
      <!-- 
      <template v-slot:dialogBtn>
        <v-list-item-icon>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click.stop="edit" fab small>
                <v-icon>mdi-account-edit</v-icon>
              </v-btn>
            </template>
            <span>Endre profil</span>
          </v-tooltip>
        </v-list-item-icon>
      </template> -->
      <template>
        <CardContent v-model="profileItems" />
      </template>
    </StandardCard>
    <EditProfileDialog
      v-model="editProfile"
      :profile="profileData"
      @save="saveProfile"
    />
    <CropperImageDialog
      v-model="addImageDialog"
      :image="image"
      @save="saveImage"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import contactpersonApi from "@/api/contactpersonApi";

import StandardCard from "@/components/shared/cards/StandardCard.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";
import EditProfileDialog from "@/components/profile/children/EditProfileDialog.vue";
import CropperImageDialog from "@/components/profile/children/CropperImageDialog.vue";
import notification from "@/helpers/notification";

export default Vue.extend({
  name: "UserCard",
  props: {
    value: {
      type: Object,
    },
  },

  data: () => ({
    addImageDialog: false,
    image: {
      src: "",
      type: "",
    },
    editProfile: false,
    profileData: null,
    hover: false,
    contactpersonApi,
  }),
  methods: {
    ...mapActions({
      setProfileImageUpdate: "shared/setProfileImageUpdate",
    }),
    edit() {
      (this as any).profileData = { ...(this as any).value };
      (this as any).editProfile = true;
    },
    saveProfile(person) {
      this.$emit("saveProfile", person);
    },
    uploadImage(event) {
      /// Reference to the DOM input element
      const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. Update the image. The type will be derived from the extension and it can lead to an incorrect result:
        this.image = {
          src: blob,
          type: files[0].type,
        };
        this.addImageDialog = true;
      }
    },

    async saveImage(formData) {
      await contactpersonApi
        .putProfilePhoto((this as any).value.person.email, formData)
        .then(() => {
          (this as any).setProfileImageUpdate();
          this.addImageDialog = false;
        })
        .catch(() => {
          notification.warn("Profilbildet ble ikke lagred");
          this.addImageDialog = false;
        });
    },
  },
  computed: {
    ...mapGetters({
      profileImageUpdate: "shared/profileImageUpdate",
    }),
    profileItems() {
      var items = [
        {
          icon: "mdi-account-hard-hat",
          title: "Tittel",
          content: this.value.person.title,
        },
        {
          icon: "mdi-email-outline",
          title: "Epost",
          content: this.value.person.email,
        },
        {
          icon: "mdi-cellphone",
          title: "Mobil",
          content: this.value.person.mobile,
        },
        {
          icon: "mdi-calendar",
          title: "Fødselsdato",
          content: this.value?.person?.birthDate
            ? moment(this.value.person.birthDate).format("DD.MM.YYYY")
            : null,
        },
        {
          icon: "mdi-card-account-details-outline",
          title: "HMS kortnummer",
          content: this.value.hmsCardNumber,
        },
        {
          icon: "mdi-calendar-month",
          title: "HMS utstedt",
          content: this.value?.hmsCardIssuedDate
            ? moment(this.value.hmsCardIssuedDate).format("DD.MM.YYYY")
            : null,
        },
      ];

      return items;
    },
  },
  components: {
    StandardCard,
    CardContent,
    EditProfileDialog,
    CropperImageDialog,
  },
});
</script>

<style lang="scss" scoped>
.editProfile {
  right: 10px;
  top: 10px;
  position: absolute;
}
// .editImage {
//   position: absolute;
// }
.overlayAvatar {
  position: absolute;
  cursor: pointer;
}
</style>
